module.exports = __webpack_public_path__ + "img/locations_large.f35bc8c9.png";